class Wishlist {
  constructor() {
    this.storageKey = 'yasari_wishlist';
    this.items = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    this.init();
    this.updateCount();
  }

  init() {
    document.querySelectorAll('.wishlist-btn').forEach((btn) => {
      const id = btn.dataset.productHandle;
      if (this.items.includes(id)) btn.classList.add('is-active');

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle(id, btn);
      });
    });
  }

  toggle(id, btn) {
    if (this.items.includes(id)) {
      this.items = this.items.filter((item) => item !== id);
      if (btn) btn.classList.remove('is-active');
    } else {
      this.items.push(id);
      if (btn) btn.classList.add('is-active');
    }
    localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    this.updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: this.items }));
  }

  remove(id) {
    this.items = this.items.filter((item) => item !== id);
    localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    this.updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: this.items }));
  }

  updateCount() {
    const counters = document.querySelectorAll('.wishlist-count');
    counters.forEach((el) => {
      el.textContent = this.items.length;
      el.classList.toggle('is-visible', this.items.length > 0);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.yasariWishlist = new Wishlist();
});